import {
  Outlet,
  createRoute,
  createRootRouteWithContext,
  Scripts
} from '@tanstack/react-router'

import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { RouterContext } from './routerContext'
import { fetchSitemodel } from 'sitemodel/shared/api/fetchSitemodel'
import Load from 'site/Load'

const rootRoute = createRootRouteWithContext<RouterContext>()({
  context: () => ({
    head: ''
  }),
  component: () => (
    <>
      <Outlet />
      <Scripts />
      <TanStackRouterDevtools />
    </>
  ),
  notFoundComponent: () => <h1>Not found!</h1>
})

const sitemodelRoute = createRoute({
  loader: async ({ params: { sitemodelUuidOrSid } }) =>
    fetchSitemodel({ sitemodelUuidOrSid }),
  getParentRoute: () => rootRoute,
  path: '/poc-ssr/$sitemodelUuidOrSid',
  component: () => {
    return <Load preloadedSitemodelData={sitemodelRoute.useLoaderData()} />
  }
})

export const tanstackRouteTree = rootRoute.addChildren([sitemodelRoute])
